'use strict';
; (function () {

    var LinkBuildingsToUsersRoutes = [
        {
            "name": "LinkBuildingsToUsers",
            "RoutingNumber": 3108,
            "settingId": 516,
            "templateUrl": "<div emr-link-buildings-to-users-main-view></div>",
            "files": [
                "AngularScripts/LinkBuildingsToUsersModule/Services/LinkBuildingsToUsersService.js",
                "AngularScripts/LinkBuildingsToUsersModule/Controllers/LinkBuildingsToUsersController.js",
            ],
        },
    ];

    angular.module('EMR.LinkBuildingsToUsersModule',[])
        .config(["$stateProvider", "EmrRouteProvider",
            function ($stateProvider, EmrRouteProvider) {
                EmrRouteProvider.registerStates(LinkBuildingsToUsersRoutes, $stateProvider);
            }]);
})();

